import { GuideTourForceClickHint } from './GuideTourForceClickHint'
import { useGuideTour } from '../provider/guideTourContext'
import { shouldShowGuideTourForceClickAffordance } from '../utils/targets'
import { expandGuideTourForceClickTargetBounds } from './guideTourForceClickAffordanceLayout'
import {
  FORCE_CLICK_AFFORDANCE_OVERFLOW_PX,
  ForceClickAffordanceAnchor,
} from './styles'

export const GuideTourForceClickAffordance = () => {
  const {
    state,
    currentStep,
    forceClickTargetBounds,
    isCurrentStepReady,
    isInModalLayer,
  } = useGuideTour()

  if (
    state.status !== 'active' ||
    !isCurrentStepReady ||
    !shouldShowGuideTourForceClickAffordance(currentStep) ||
    !forceClickTargetBounds
  ) {
    return null
  }

  const expandedBounds = expandGuideTourForceClickTargetBounds(
    forceClickTargetBounds,
    FORCE_CLICK_AFFORDANCE_OVERFLOW_PX
  )

  return (
    <ForceClickAffordanceAnchor
      data-testid="guide-tour-force-click-affordance"
      elevated={isInModalLayer}
      aria-hidden
      style={{
        top: expandedBounds.top,
        left: expandedBounds.left,
        width: expandedBounds.width,
        height: expandedBounds.height,
      }}
    >
      <GuideTourForceClickHint bounds={forceClickTargetBounds} />
    </ForceClickAffordanceAnchor>
  )
}
